import { ValidatorsProps, Response, apiAbortController } from '@ui/src';
import { Group } from '../../types';

import api from '../../../../api/api';

export interface CreateGroupValidatorResponse {
  data: {
    createAccountGroupSchema: ValidatorsProps;
  };
}

export interface GroupFormValues {
  categoryId: string;
  description: string;
  active?: boolean;
}

export const accountsGroupsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCreateGroupValidator: build.query<CreateGroupValidatorResponse, void>({
      query: () => ({
        url: '/v1/accounts-groups/validators',
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsGroups: build.query<Response<Group>, string>({
      query: (query) => ({
        url: `/v1/accounts-groups?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createGroup: build.mutation<{ data: Group }, any>({
      query: (body: GroupFormValues) => ({
        url: '/v1/accounts-groups',
        method: 'POST',
        body: {
          description: body.description,
          categoryId: body.categoryId,
          active: true,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateGroup: build.mutation<
      { data: Group },
      { body: GroupFormValues; id: string }
    >({
      query: (data: { body: GroupFormValues; id: string }) => ({
        url: `/v1/accounts-groups/${data.id}`,
        method: 'PUT',
        body: {
          description: data.body.description,
          active: data.body.active,
        },
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getAccountsGroup: build.query<{ data: Group }, string>({
      query: (id) => ({
        url: `/v1/accounts-groups/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useGetCreateGroupValidatorQuery,
  useCreateGroupMutation,
  useGetAccountsGroupsQuery,
  useLazyGetAccountsGroupQuery,
  useLazyGetAccountsGroupsQuery,
  useUpdateGroupMutation,
} = accountsGroupsApi;

export const {
  endpoints: { getCreateGroupValidator, createGroup, updateGroup },
} = accountsGroupsApi;
